'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DangerAlertIcon = function DangerAlertIcon(_ref) {
  var fill = _ref.fill,
      props = _objectWithoutProperties(_ref, ['fill']);

  return _react2.default.createElement(
    _Icon2.default,
    props,
    _react2.default.createElement(
      'svg',
      { style: { display: 'block' }, width: '100%', height: '100%', viewBox: '0 0 16 16' },
      _react2.default.createElement('path', { fill: fill, fillRule: 'evenodd', d: 'M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 14c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zM7 4v5h2V4H7zm1 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2z' })
    )
  );
};

DangerAlertIcon.propTypes = _extends({}, _Icon2.default.propTypes);

DangerAlertIcon.defaultProps = _extends({}, _Icon2.default.defaultProps, {
  size: 'small',
  fill: _theme2.default.colors.danger
});

exports.default = DangerAlertIcon;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21wb25lbnRzL0RhbmdlckFsZXJ0SWNvbi5qcyJdLCJuYW1lcyI6WyJEYW5nZXJBbGVydEljb24iLCJmaWxsIiwicHJvcHMiLCJkaXNwbGF5IiwicHJvcFR5cGVzIiwiZGVmYXVsdFByb3BzIiwic2l6ZSIsImNvbG9ycyIsImRhbmdlciJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7QUFBQTs7OztBQUNBOzs7O0FBQ0E7Ozs7Ozs7O0FBRUEsSUFBTUEsa0JBQWtCLFNBQWxCQSxlQUFrQixPQUF3QjtBQUFBLE1BQXJCQyxJQUFxQixRQUFyQkEsSUFBcUI7QUFBQSxNQUFaQyxLQUFZOztBQUM5QyxTQUNFO0FBQUE7QUFBVUEsU0FBVjtBQUNFO0FBQUE7QUFBQSxRQUFLLE9BQU8sRUFBRUMsU0FBUyxPQUFYLEVBQVosRUFBa0MsT0FBTSxNQUF4QyxFQUErQyxRQUFPLE1BQXRELEVBQTZELFNBQVEsV0FBckU7QUFDRSw4Q0FBTSxNQUFNRixJQUFaLEVBQWtCLFVBQVMsU0FBM0IsRUFBcUMsR0FBRSx3SkFBdkM7QUFERjtBQURGLEdBREY7QUFPRCxDQVJEOztBQVVBRCxnQkFBZ0JJLFNBQWhCLGdCQUNLLGVBQUtBLFNBRFY7O0FBSUFKLGdCQUFnQkssWUFBaEIsZ0JBQ0ssZUFBS0EsWUFEVjtBQUVFQyxRQUFNLE9BRlI7QUFHRUwsUUFBTSxnQkFBTU0sTUFBTixDQUFhQztBQUhyQjs7a0JBTWVSLGUiLCJmaWxlIjoiRGFuZ2VyQWxlcnRJY29uLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IEljb24gZnJvbSAnLi9JY29uJ1xuaW1wb3J0IHRoZW1lIGZyb20gJy4vdGhlbWUnXG5cbmNvbnN0IERhbmdlckFsZXJ0SWNvbiA9ICh7IGZpbGwsIC4uLnByb3BzIH0pID0+IHtcbiAgcmV0dXJuIChcbiAgICA8SWNvbiB7Li4ucHJvcHN9PlxuICAgICAgPHN2ZyBzdHlsZT17eyBkaXNwbGF5OiAnYmxvY2snIH19IHdpZHRoPScxMDAlJyBoZWlnaHQ9JzEwMCUnIHZpZXdCb3g9JzAgMCAxNiAxNic+XG4gICAgICAgIDxwYXRoIGZpbGw9e2ZpbGx9IGZpbGxSdWxlPSdldmVub2RkJyBkPSdNOCAwQzMuNiAwIDAgMy42IDAgOHMzLjYgOCA4IDggOC0zLjYgOC04LTMuNi04LTgtOHptMCAxNGMtMy4zIDAtNi0yLjctNi02czIuNy02IDYtNiA2IDIuNyA2IDYtMi43IDYtNiA2ek03IDR2NWgyVjRIN3ptMSA4YTEgMSAwIDEgMCAwLTIgMSAxIDAgMCAwIDAgMnonIC8+XG4gICAgICA8L3N2Zz5cbiAgICA8L0ljb24+XG4gIClcbn1cblxuRGFuZ2VyQWxlcnRJY29uLnByb3BUeXBlcyA9IHtcbiAgLi4uSWNvbi5wcm9wVHlwZXNcbn1cblxuRGFuZ2VyQWxlcnRJY29uLmRlZmF1bHRQcm9wcyA9IHtcbiAgLi4uSWNvbi5kZWZhdWx0UHJvcHMsXG4gIHNpemU6ICdzbWFsbCcsXG4gIGZpbGw6IHRoZW1lLmNvbG9ycy5kYW5nZXJcbn1cblxuZXhwb3J0IGRlZmF1bHQgRGFuZ2VyQWxlcnRJY29uXG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../~/@segment/react-ui-library/lib/components/DangerAlertIcon.js
// module id = 579
// module chunks = 0